var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setup-container" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center", align: "middle" } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 20, md: 16, lg: 12, xl: 10 } },
            [
              _c(
                "el-card",
                { staticClass: "selection-card" },
                [
                  _c("el-row", { attrs: { gutter: 20 } }, [
                    _c("div", { staticClass: "icons" }, [
                      _c("i", { staticClass: "el-icon-monitor" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "laptop-icon" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-mobile-phone" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "step-indicator" }, [
                          _c("div", { staticClass: "step-text" }, [
                            _vm._v("STEP 2 OF 3")
                          ])
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("h1", { staticClass: "title" }, [
                          _vm._v("Finish setting up your account")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "description" }, [
                          _vm._v(
                            "\n                  UNIFI is personalized for you."
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                  Create a password and start getting deals done!\n                "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "next-button",
                              attrs: { type: "primary" },
                              on: { click: _vm.goNext }
                            },
                            [_vm._v("Next")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65453afc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65453afc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectUserDetailsStep.vue
// module id = null
// module chunks = 